/*
 * Copyright (C) 2020 to Present Applause App Quality, Inc. All rights reserved.
 */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LinkComponent } from './link.component';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    LinkComponent
  ],
  exports: [
    LinkComponent,
  ]
})
export class LinkModule { }
